package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun TermsAndPrivacyText(
    modifier: Modifier = Modifier,
    conditionsPath: String = "",
    privacyPath: String = "",
    isMobile: Boolean = false
) {

    if (isMobile) {
        Column(
            modifier = modifier.margin(top = 28.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(
                modifier = Modifier.gap(4.px),
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(
                    text = "En continuant, vous acceptez nos",
                    modifier = Modifier
                        .fontSize(12.px).fontFamily(INTER)
                        .fontWeight(FontWeight.Light).color(Colors.Primary)
                )
                Link(
                    path = conditionsPath, text = "conditions",
                    modifier = Modifier
                        .fontSize(12.px).fontFamily(INTER)
                        .color(Colors.lighterblue).fontWeight(FontWeight.Light)
                        .textDecorationLine(TextDecorationLine.None)
                )
            }
            Row(
                modifier = Modifier.gap(4.px),
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(
                    text = "et notre",
                    modifier = Modifier
                        .fontSize(12.px).fontFamily(INTER)
                        .fontWeight(FontWeight.Light).color(Colors.Primary)
                )
                Link(
                    path = privacyPath, text = "politique de confidentialité.",
                    modifier = Modifier
                        .fontSize(12.px).fontFamily(INTER)
                        .color(Colors.lighterblue).fontWeight(FontWeight.Light)
                        .textDecorationLine(TextDecorationLine.None)
                )
            }
        }
    } else {
        Row(
            modifier = modifier
                .margin(top = 28.px)
                .gap(4.px),
            horizontalArrangement = Arrangement.Center
        ) {
            SpanText(
                text = "En continuant, vous acceptez nos",
                modifier = Modifier
                    .fontSize(13.px)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
                    .color(Colors.Primary)
            )

            Link(
                path = conditionsPath,
                text = "conditions",
                modifier = Modifier
                    .fontSize(13.px)
                    .fontFamily(INTER)
                    .color(Colors.lighterblue)
                    .fontWeight(FontWeight.Light)
                    .textDecorationLine(TextDecorationLine.None)
            )

            SpanText(
                text = "et notre",
                modifier = Modifier
                    .fontSize(13.px)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
                    .color(Colors.Primary)
            )

            Link(
                path = privacyPath,
                text = "politique de confidentialité.",
                modifier = Modifier
                    .fontSize(13.px)
                    .fontFamily(INTER)
                    .color(Colors.lighterblue)
                    .fontWeight(FontWeight.Light)
                    .textDecorationLine(TextDecorationLine.None)
            )
        }
    }
}